<template>
  <vue-slider
    :ref="name"
    :value="value"
    width="100%"
    :tooltip="tooltip"
    tooltip-dir="bottom"
    :bg-style="bgStyle"
    :tooltip-style="tooltipStyle"
    :process-style="processStyle"
    :slider-style="sliderStyle"
    :interval="interval"
    v-bind="$props"
    @callback="onChange"
  />
</template>

<script>
  import vueSlider from 'vue-slider-component'
  import * as colors from '@/colors'

  export default {
    name: 'XSlider',
    components: {
      vueSlider
    },
    props: {
      value: [Number, String, Array],
      min: Number,
      max: Number,
      interval: Number,
      tooltip: {
        type: [Boolean, String],
        default: 'always'
      },
      name: String
    },
    data () {
      return {
        bgStyle: {
          backgroundColor: colors.diamond,
          height: '8px',
          borderRadius: '12px'
        },
        tooltipStyle: {
          backgroundColor: 'transparent',
          borderColor: 'transparent',
          color: colors.galaxy,
          fontWeight: 600,
          fontSize: '1.6rem'
        },
        processStyle: {
          backgroundColor: APP_THEME.palette.primary.main
        },
        sliderStyle: {
          backgroundColor: 'white',
          border: `3px solid ${APP_THEME.palette.primary.main}`,
          boxShadow: 'none',
          marginTop: '1px'
        }
      }
    },
    methods: {
      onChange (value) {
        this.$emit('update', value)
      },
      setCurrentValue (name, val) {
        this.$refs[name].setCurrentValue(val)
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

</style>
